import React, {useState} from 'react';
import {colors} from 'styles/colors';
import styled from 'styled-components';
import DefaultText from './DefaultText';
import {minmax} from 'utils/minmax';

/**
 * 파일 입력 버튼 컴포넌트의 Props 타입
 * @property {any} title - 버튼 제목
 * @property {React.CSSProperties} [labelStyle] - 라벨 스타일
 * @property {string} [accept] - 허용 파일 타입
 * @property {any} setValue - 파일 설정 함수
 * @property {boolean} active - 활성화 여부
 * @property {boolean} [disabled] - 비활성화 여부
 */
type Props = {
  title: any;
  labelStyle?: React.CSSProperties;
  accept?: string;
  setValue: any;
  active: boolean;
  disabled?: boolean;
};

/**
 * 파일 입력 버튼 컴포넌트
 * 파일 선택 기능을 제공하는 버튼 컴포넌트입니다.
 * @param {Props} props - 파일 입력 버튼 컴포넌트의 props
 * @returns {JSX.Element} 파일 입력 버튼 컴포넌트
 */
const FileInputButton = ({
  title,
  labelStyle,
  accept,
  setValue,
  active,
  disabled,
}: Props) => {
  // 동일한 파일 다시 등록 가능하도록 설정
  const [fileInputKey, setFileInputKey] = useState(0);
  return (
    <Label style={labelStyle} $active={active}>
      <DefaultText text={title} textStyle={{color: colors.white}} />
      <input
        key={fileInputKey}
        type="file"
        accept={accept} // 신뢰 ㄴㄴ, 모든 파일로도 accept 이외의 다른 파일 선택 가능
        disabled={!active || disabled}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          if (active) {
            const file: FileList | null = event.target.files;

            if (!file) return;

            setFileInputKey(prevKey => prevKey + 1);
            setValue(file[0]);
          }
        }}
      />
    </Label>
  );
};

export default FileInputButton;

const Label = styled.label<{$active?: boolean}>`
  width: 100%;
  height: 100%;
  min-height: ${minmax(40)};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props: any) =>
    props.$active ? colors.primary2 : colors.lightGrey};
  border-radius: ${minmax(10)};
  color: ${colors.white};
  cursor: ${(props: any) => (props.$active ? 'pointer' : 'default')};

  input {
    display: none;
  }
`;
